import UnstyledInfo from "@mui/icons-material/Info";
import { styled } from "@mui/material";

import { Tooltip as UnstyledTooltip } from "@citrine/atoms/tooltip";

export const InfoIcon = styled(UnstyledInfo)(({ theme }) => ({
  color: theme.palette.grey[600],
  ":hover": {
    color: theme.palette.grey[500],
  },
}));

export const Header = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontWeight: "bold",
  textTransform: "uppercase",
}));

export const Tooltip = styled(UnstyledTooltip)(({ theme }) => ({
  padding: theme.spacing(1.5),
}));
